import React, { useEffect, useState } from 'react'
import Navbar from './navbar/Navbar'
import Footer from './footer/Footer'
import WhatsAppFloat from './WhatsAppFloat'
import CouponFloat from './CouponFloat'
import { useAuth } from '../contexts/AuthContext'
import { getFloatCoupons } from '../services/coupons'
import type { FloatCoupon } from '../services/coupons'

const DEFAULT_FLOAT_COUPON: FloatCoupon[] = [{ code: 'LOYAL35', value: 35, type: 'percent' }]

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { user } = useAuth()
  const [floatCoupons, setFloatCoupons] = useState<FloatCoupon[]>([])

  useEffect(() => {
    if (!user) {
      setFloatCoupons([])
      return
    }
    getFloatCoupons()
      .then(setFloatCoupons)
      .catch(() => setFloatCoupons([]))
  }, [user])

  return (
    <div className="min-h-screen bg-bg text-text">
      <Navbar />
      <main>
        {children}
      </main>
      <Footer />
      <WhatsAppFloat />
      {user ? <CouponFloat coupons={floatCoupons.length > 0 ? floatCoupons : DEFAULT_FLOAT_COUPON} /> : null}
    </div>
  )
}

export default Layout